import React from "react";
import "../style/RowCard.css";

function RowCard(props) {
  const { data, columnWidths, mode, padding = "0px", compact } = props;
  // mode = "grid" | "centered" | "stats"

  if (mode === "grid") {
    const gridTemplateColumns = columnWidths.join(" ");
    return (
      <div
        className="rounded"
        style={{
          width: "100%",
          backgroundColor: "white",
          display: "grid",
          gridTemplateColumns,
          padding,
          fontWeight: "bold",
          gridTemplateRows: "1fr",
        }}
      >
        {data.map((column, index) => {
          return <div key={index}>{column}</div>;
        })}
      </div>
    );
  } else if (mode === "stats") {
    return (
      <div className={`rounded rowCardStats${compact ? " rowCardStatsCompact" : ""}`} style={{ padding }}>
        {data.map((stat, index) => {
          return (
            <div key={index} className="rowCardStatTile">
              <div className="rowCardStatLabel">{stat.label}</div>
              <div className="rowCardStatValue">{stat.value}</div>
            </div>
          );
        })}
      </div>
    );
  } else if (mode === "centered") {
    return (
      <div
        className="rounded"
        style={{
          width: "100%",
          backgroundColor: "white",
          display: "flex",
          justifyContent: "space-around",
          padding,
          fontWeight: "bold",
        }}
      >
        {data.map((column, index) => {
          return <div key={index}>{column}</div>;
        })}
      </div>
    );
  }
}

export default RowCard;
